import { z } from 'zod';

export const medicineSchema = z.object({
  name: z.string().min(1, 'Medicine name is required').max(100, 'Name too long'),
  genericName: z.string().optional(),
  brandName: z.string().optional(),
  strength: z.string().min(1, 'Strength is required (e.g., 500mg)'),
  form: z.enum(['tablet', 'capsule', 'syrup', 'injection', 'ointment', 'other']),
  route: z.enum(['oral', 'iv', 'im', 'topical', 'inhalation', 'other']).optional(),
  manufacturer: z.string().optional(),
  reorderLevel: z.number().min(0, 'Reorder level must be 0 or greater'),
  status: z.enum(['active', 'inactive']),
});

export type MedicineFormData = z.infer<typeof medicineSchema>;
